var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"sfx_show"}},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.sfx.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }